module.exports = __webpack_public_path__ + "img/about.238e41e6.jpeg";